import Modal from "bootstrap/js/dist/modal";
import Carousel from "bootstrap/js/dist/carousel";
import "bootstrap";
import "./extended-cards";
import "./testimonial";
import "./award";

window.addEventListener("DOMContentLoaded", (event) => {
  window.Carousel = Carousel;
  window.Modal = Modal;

  if (window.innerWidth > 992) {
    // Hover navbar
    var mainNavMenu = document.querySelector("#menu-primary-navigation");
    mainNavMenu.querySelectorAll(".nav-item").forEach(function (everyitem) {
      everyitem.addEventListener("mouseover", function (e) {
        let el_link = this.querySelector("a[data-bs-toggle]");

        if (el_link != null) {
          let nextEl = el_link.nextElementSibling;
          el_link.classList.add("show");
          nextEl.classList.add("show");
        }
      });
      everyitem.addEventListener("mouseleave", function (e) {
        let el_link = this.querySelector("a[data-bs-toggle]");

        if (el_link != null) {
          let nextEl = el_link.nextElementSibling;
          el_link.classList.remove("show");
          nextEl.classList.remove("show");
        }
      });
    });
  }

  if (document.querySelector(".our-story-video")) {
    const videoWrapper = document.querySelector(".video-wrapper");
    const video = videoWrapper.querySelector(".our-story-video");
    const playButton = videoWrapper.querySelector(".custom-play-button");

    playButton.addEventListener("click", function () {
      playButton.classList.add("hidden");
      video.setAttribute("controls", "controls");
      video.play();
    });
  }
});
